// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_checkpoint_model from "./web_checkpoint_model.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  t.revision = t.revision + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  t.loading = false;
  t.dirty = false;
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)))) {
    return;
  } else {
    return "/api/workspaces/" + (match._0 + ("/sessions/" + (match._2 + "/checkpoint")));
  }
}

function active(t, gen) {
  if (gen === t.generation) {
    return path(t) !== undefined;
  } else {
    return false;
  }
}

function refresh(t) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  if (t.loading) {
    t.dirty = true;
    return;
  }
  t.loading = true;
  t.dirty = false;
  const gen = t.generation;
  const rev = t.revision;
  Mapre_web__Browser.request(t.controller, undefined, undefined, path$1).then(function (result) {
    if (active(t, gen)) {
      t.loading = false;
      if (rev !== t.revision) {
        t.dirty = true;
      } else if (result.TAG === /* Ok */ 0) {
        try {
          const action = {
            TAG: /* Loaded */ 0,
            _0: Mapre_web__Web_checkpoint_model.decode(result._0)
          };
          Curry._1(t.emit, {
            TAG: /* Checkpoint */ 46,
            _0: action
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          }
          
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        }
        
      }
      if (t.dirty) {
        refresh(t);
      }
      
    }
    return Promise.resolve();
  });
}

function failed(t, error) {
  if (/* tag */ typeof error !== "object" && typeof error !== "function") {
    switch (error) {
      case /* Unauthorized */ 0 :
        return Curry._1(t.failure, error);
      case /* Forbidden */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Checkpoint */ 46,
          _0: {
            TAG: /* Failed */ 2,
            _0: "Permission denied. Refresh access before saving a checkpoint."
          }
        });
      case /* Invalid_response */ 2 :
        Curry._1(t.emit, {
          TAG: /* Checkpoint */ 46,
          _0: /* Uncertain */ 0
        });
        return refresh(t);
    }
  } else {
    if (error.TAG === /* Missing */ 0) {
      return Curry._1(t.failure, error);
    }
    switch (error._0) {
      case "checkpoint_runtime_unavailable" :
        return Curry._1(t.emit, {
          TAG: /* Checkpoint */ 46,
          _0: {
            TAG: /* Failed */ 2,
            _0: "This session runtime does not support checkpoints. Start a session from an updated template."
          }
        });
      case "checkpoint_intent_conflict" :
      case "checkpoint_turn_unconfirmed" :
      case "publication_source_changed" :
      case "publication_source_missing" :
      case "run_changed" :
      case "version_conflict" :
        break;
      default:
        Curry._1(t.emit, {
          TAG: /* Checkpoint */ 46,
          _0: /* Uncertain */ 0
        });
        return refresh(t);
    }
    Curry._1(t.emit, {
      TAG: /* Checkpoint */ 46,
      _0: {
        TAG: /* Failed */ 2,
        _0: "The run changed. Refresh checkpoint status before trying again."
      }
    });
    return refresh(t);
  }
}

function send(t, attempt) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  t.revision = t.revision + 1 | 0;
  Curry._1(t.emit, {
    TAG: /* Checkpoint */ 46,
    _0: {
      TAG: /* Started */ 1,
      _0: {
        id: attempt.id,
        run_id: attempt.run_id,
        version: attempt.version,
        uncertain: false
      }
    }
  });
  const gen = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, Mapre_web__Web_checkpoint_model.body(attempt), path$1).then(function (result) {
    if (active(t, gen) && Stdlib__Option.fold(false, (function (a) {
        if (a.id === attempt.id) {
          return a.run_id === attempt.run_id;
        } else {
          return false;
        }
      }), Curry._1(t.model, undefined).checkpoint.attempt)) {
      t.revision = t.revision + 1 | 0;
      if (result.TAG === /* Ok */ 0) {
        try {
          const cp = Mapre_web__Web_checkpoint_model.decode_checkpoint(result._0);
          if (cp.id !== attempt.id || cp.run_id !== attempt.run_id) {
            failed(t, /* Invalid_response */ 2);
          } else {
            refresh(t);
          }
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            failed(t, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        failed(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function dispatch(t, action) {
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Checkpoint */ 46,
      _0: action
    });
  }
  switch (action) {
    case /* Submit */ 1 :
      const m = Curry._1(t.model, undefined);
      if (!(Mapre_web__Web_model.can_create(m) && Mapre_web__Web_checkpoint_model.can_submit(m.checkpoint))) {
        return;
      }
      const c = Stdlib__Option.get(m.checkpoint.control);
      return send(t, {
        id: crypto.randomUUID(),
        run_id: Stdlib__Option.get(c.run_id),
        version: c.version,
        uncertain: false
      });
    case /* Retry */ 2 :
      const m$1 = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(m$1)) {
        return Stdlib__Option.iter((function (a) {
          if (a.uncertain) {
            return send(t, a);
          }
          
        }), m$1.checkpoint.attempt);
      } else {
        return;
      }
    case /* Refresh */ 3 :
      const gen = t.generation;
      if (path(t) !== undefined) {
        Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
          if (active(t, gen)) {
            if (result.TAG === /* Ok */ 0) {
              try {
                Curry._1(t.emit, {
                  TAG: /* Workspaces */ 1,
                  _0: Mapre_web__Web_codec.workspaces(result._0)
                });
                refresh(t);
              }
              catch (raw_exn){
                const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
                  Curry._1(t.failure, /* Invalid_response */ 2);
                } else {
                  throw exn;
                }
              }
            } else {
              Curry._1(t.failure, result._0);
            }
          }
          return Promise.resolve();
        });
        return;
      } else {
        return;
      }
    default:
      return Curry._1(t.emit, {
        TAG: /* Checkpoint */ 46,
        _0: action
      });
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    revision: 0,
    controller: new AbortController(),
    loading: false,
    dirty: false
  };
}

export {
  create,
  cancel,
  refresh,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
